import {
  SELECT_USER_GROUP_DATA,
  GET_GROUP_PRICE_USER,
  ALL_GROUP_USER_DATA,
  ACTION_GET_GROUP_USERS_RELATION,
  ACTION_GET_COMBO_STYPE_PANEL,
  ACTION_GET_GROUP_MODEL_FACTOR,
  USER_SEARCH,NAME_USER_DEFAULT
} from "Stores/actionTypes";
import { updateObject } from "./utility";

const initialState = {
  userGroupData: [],
  groupPriceUser: [],
  allGroupUserData: [],
  userGroupDataPagination: { Limit: 10, Page: 1, Total: 0 },
  dataRelationGroupUsers: [],
  dataComboStypePanel: [],
  groupModelFactors: [],
  userGroupDataSearch:null,
  nameUserDefault:null
};

const UserReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GROUP_PRICE_USER:
      return updateObject(state, { groupPriceUser: action.groupPriceUser });
    case NAME_USER_DEFAULT:
      return updateObject(state, { nameUserDefault: action.nameUserDefault });
    case SELECT_USER_GROUP_DATA:
      return updateObject(state, {
        userGroupData: action.userGroupData,
        userGroupDataPagination: action.userGroupDataPagination,
      });
      case USER_SEARCH:
        return updateObject(state, {
          userGroupDataSearch: action.userGroupDataSearch,
        });
    case ALL_GROUP_USER_DATA:
      return updateObject(state, {
        allGroupUserData: action.allGroupUserData,
      });
    case ACTION_GET_GROUP_USERS_RELATION:
      return updateObject(state, {
        dataRelationGroupUsers: action.dataRelationGroupUsers,
      });

    case ACTION_GET_COMBO_STYPE_PANEL:
      return updateObject(state, {
        dataComboStypePanel: action.dataComboStypePanel,
      });
    case ACTION_GET_GROUP_MODEL_FACTOR:
      return updateObject(state, {
        groupModelFactors: action.groupModelFactors,
      });

    default:
      return state;
  }
};

export default UserReducer;
